import { cn } from "@getgreenline/blaze-ui";

type FormFieldLabelProps = {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
  helperText?: React.ReactNode;
  helperInline?: boolean;
};

export function FormFieldLabel({
  children,
  htmlFor,
  className,
  helperText,
  helperInline = false,
}: FormFieldLabelProps) {
  const content = (
    <span
      className={cn(
        "tw:mb-2 tw:block tw:text-sm tw:font-medium tw:text-foreground",
        helperInline && "tw:mb-0",
        className,
      )}
    >
      <span>{children}</span>
      {helperText ? (
        <span
          className={cn(
            "tw:font-normal tw:text-muted-foreground/80",
            helperInline ? "tw:ml-3 tw:text-xs" : "tw:mt-1 tw:block tw:text-sm",
          )}
        >
          {helperText}
        </span>
      ) : null}
    </span>
  );

  if (htmlFor) {
    return <label htmlFor={htmlFor}>{content}</label>;
  }

  return <div>{content}</div>;
}
